import { useState } from 'react';
import type { FaqItem } from '@/mocks/faq';

interface Props {
  items: FaqItem[];
  defaultOpenId?: string;
}

export default function FaqAccordion({ items, defaultOpenId }: Props) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div
            key={item.id}
            className={`rounded-lg border bg-background-50 transition-colors ${
              open ? 'border-primary-300' : 'border-background-200'
            }`}
          >
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(open ? null : item.id)}
                aria-expanded={open}
                aria-controls={`faq-panel-${item.id}`}
                className="w-full flex items-start justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950">{item.q}</span>
                <span className="w-6 h-6 shrink-0 flex items-center justify-center mt-0.5">
                  <i className={open ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-400'}></i>
                </span>
              </button>
            </h3>
            <div id={`faq-panel-${item.id}`} className={open ? 'block' : 'hidden'}>
              <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}